import { PictureImage } from '@freelancer/ui/picture';

export enum FinopsErrorType {
  ERROR = 'error', // Finops errors
  ERROR_AUTH = 'error_auth', // Auth issues
  ERROR_INIT = 'error_init', // Error on page load
  ERROR_UNKNOWN = 'error_unknown', // Unhandled exceptioins
  ERROR_DATASTORE = 'error_datastore', // Datastore errors
}

export enum FinopsEventType {
  INITIALIZED = 'initialized', // site is ready to go
  CLOSE_OVERLAY = 'close_overlay', // event to close an overlay
}

export enum FinopsResultStatus {
  SUCCESS = 'success',
  PENDING = 'pending', // Pending Finopss
  INTERRUPTED = 'interrupted', // Finops action cancelled
  REDIRECT = 'redirect', // From modal - redirecting to Finops page
}

export interface FinopsError {
  errorType: FinopsErrorType; // todo: errorCode & errorMessage should be related, probs one is enough
  cta?: string;
  ctaLink?: string;
  errorCode?: string;
  errorMessage?: string;
  eventId?: string;
}

// These boys are used for internal event communication
// where we don't care about message, just about the type of event
export interface FinopsEvent {
  eventType: FinopsEventType;
}

// Use this type after user attempted a Finops and it didn't return an error
export interface FinopsResult {
  finopsStatus: FinopsResultStatus;
  cta?: string;
  ctaLink?: string;
  finopsMessage?: string;
}

export enum OverlayTypes {
  BLOCKING_ERROR,
  CC_3DS,
  CC_CAPTCHA,
  DEPOSIT_SUCCESS,
  EXTERNAL_POPUP,
  VERIFICATION_SUCCESS,
}

// This one is emitted when we want to display an overlay.
export interface FinopsOverlay {
  brand?: PictureImage;
  ctaAction: Function;
  onClose?: Function;
  overlayType: OverlayTypes;
}

// messages to be transmitted over FinopsOverlay subject pipe
export enum FinopsOverlayAction {
  CLOSE,
}

export type FinopsMessage =
  | FinopsOverlay
  | FinopsResult
  | FinopsEvent
  | FinopsError;

export function isFinopsEvent(
  finopsResult: FinopsMessage,
): finopsResult is FinopsEvent {
  return (finopsResult as FinopsEvent).eventType !== undefined;
}

export function isFinopsResult(
  finopsResult: FinopsMessage,
): finopsResult is FinopsResult {
  return (finopsResult as FinopsResult).finopsStatus !== undefined;
}

export function isFinopsOverlay(
  finopsResult: FinopsMessage,
): finopsResult is FinopsOverlay {
  return (finopsResult as FinopsOverlay).overlayType !== undefined;
}

export function isFinopsError(
  finopsResult: FinopsMessage,
): finopsResult is FinopsError {
  return (finopsResult as FinopsError).errorType !== undefined;
}
